/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Result_Action_Dataset_UnavailableInputs */



/**
* | output |
* | --- |
* | "Current dataset (not available to you)" |
*
* @param {Agent_Builder_Result_Action_Dataset_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_dataset_unavailable = /** @type {((inputs?: Agent_Builder_Result_Action_Dataset_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_Dataset_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktueller Datensatz (für Sie nicht verfügbar)")
	return /** @type {LocalizedString} */ ("Current dataset (not available to you)")
});